<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="12" sm="6">
        <h1>SUBSCRIPTION(All)</h1>
      </v-col>

      <v-col class="d-flex" cols="12" sm="4">
      <v-text-field label="Search For Anything Across System"></v-text-field>
      </v-col>

      <v-col class="d-flex" cols="12" sm="2">
       <div class="my-8">
         <AddSubcription/>
       </div>
      </v-col> 
    </v-row>
    <hr/>    
    <v-row align="center">
      <v-col cols="12" sm="2">
        <h3>Filter By</h3>
      </v-col>  
      <v-col class="d-flex" cols="12" sm="2">
      <v-select
          :items="['Paid','Un-Paid']"
          label="Paid Status"
          v-model="paidstatus"
          clearable="true"
        ></v-select>
      </v-col>

      <v-col class="d-flex" cols="12" sm="2">
      <v-select
          :items="['Domain','SSL Certificate','Hosting','Gsuit','Ads']"
          label="Type"
          v-model="type"
          clearable="true"
        ></v-select>
      </v-col>

      <v-col class="d-flex" cols="12" sm="2">
        <v-select
          :items="['Running','Suspended']"
          label="Status"
          v-model="status"
          clearable="true"
        ></v-select>
      </v-col>

      <v-col class="d-flex" cols="12" sm="2">
        <v-text-field label="Filter By Product Name" v-model="product"></v-text-field>
      </v-col>
    </v-row>
    <hr/>
    <v-data-table
    :headers="headers"
    :items="filteredSubscription"
    class="elevation-1"
  >
    <template v-slot:item.status="{ item }">
      <v-chip class="ma-2" color="green" text-color="white"
        v-if="item.status == 'Running'" small>{{ item.status }}</v-chip>
      <v-chip class="ma-2" color="red" text-color="white"
        v-if="item.status == 'Suspended'" small>{{ item.status }}</v-chip>
    </template>
    <template v-slot:item.paid_until="{ item }">
      <v-chip class="ma-2" color="green" text-color="white"
        v-if="item.paid_until == 'Paid'" small>{{ item.paid_until }}</v-chip>
      <v-chip class="ma-2" color="yellow" text-color="black"
        v-if="item.paid_until == 'Un-Paid'" small>{{ item.paid_until }}</v-chip>
    </template>
    <template v-slot:item.action="{ item }">
      <div class="w-80">
      <ShowSubscription :subscriptionid="item.id" :subscription="item"/>
      <SubscriptionEditModal :subscriptionid="item.id" class="mx-2"/>
      <PaymentModal :payments="item.subscription_payment" :subscriptionid="item.id" class="mx-2"/>
      </div>
    </template>

  </v-data-table>
  </v-container>
</template>
<style>
a {
  text-decoration: none;
}
</style>
<script>
import { mapGetters,mapActions } from 'vuex';
import AddSubcription from './AddSubscription.vue';
import ShowSubscription from './ShowSubscription.vue';
import SubscriptionEditModal from './SubscriptionEditModal.vue';
import PaymentModal from './PaymentModal.vue';

  export default {
    components: {
      AddSubcription,
      ShowSubscription,
      SubscriptionEditModal,
      PaymentModal
    },
    data () {
      return {
        headers: [
          {
            text: 'Product',
            align: 'start',
            sortable: false,
            value: 'product',
          },
          { text: 'Type', value: 'type' },
          { text: 'Client', value: 'client.name' },
          { text: 'Paid Until', value: 'paid_until_date' },
          { text: 'Status', value: 'status' },
          { text: 'Paid Status', value: 'paid_until' },
          { text: 'action', value: 'action' },
        ],
        product: '',
        status: '',
        type: '',
        paidstatus: '',
        client_id: '',
        rules: [
          value => !!value || 'Required.',
        ],
      }
    },
    mounted() {
      this.isloggedin = !!localStorage.getItem('token');
      if(this.isloggedin)
      {
          this.fetchsubscriptions().then(() => {
          this.$store.dispatch('showsnackbar',{ message: "All Data Retrieved Successfully..", color: "success" });
        })
        .catch((error) => {
          this.$store.dispatch('showsnackbar',{ message: error, color: "error" });
        });
      }
    },
    methods: {
      ...mapActions(['fetchsubscriptions','showsnackbar']),
    },
    computed: {
      ...mapGetters(["allsubscriptions"]),
      filteredSubscription() {
        return this.allsubscriptions.filter(project => { 
            if(this.status) { return this.status === project.status;}
            return true;
        })
        .filter(project => {
            if(this.type) { return this.type === project.type;}
            return true;
        })
        .filter(project => {
            if(this.paidstatus) { return this.paidstatus === project.paid_until;}
            return true;
        })
        .filter(project => {
          
            if(this.product) {
              return project.product.toLowerCase().indexOf(this.product.toLowerCase()) > -1; 
              // return project.product.includes(this.product);
            }
            return true;
        });
      }
    },
    filters: {
        paidstatus(value){
          if(value){
            return "Paid";
          }
        }
    }
  }
</script>